import { useState } from 'react';

const faqs = [
  {
    question: '福利视频导是什么？',
    answer: '福利视频导是一个视频内容聚合导航平台，我们通过智能推荐算法与人工精选相结合，为用户提供全网优质视频资源的精准分类导航服务，帮助用户快速发现感兴趣的视频内容。',
  },
  {
    question: '福利视频导的视频资源来自哪里？',
    answer: '福利视频导聚合了多个主流视频平台（如B站、抖音、YouTube等）的优质内容，通过分类整理和智能推荐，为用户提供一站式的视频发现体验。我们不存储视频文件，只提供导航与推荐服务。',
  },
  {
    question: '如何使用福利视频导的分类导航？',
    answer: '在首页点击任意分类卡片，或在顶部导航栏选择"视频分类"，即可进入分类浏览页面。每个分类下都有精选的视频文章和推荐内容，点击文章卡片可查看详细内容与视频推荐。',
  },
  {
    question: '福利视频导是否收费？',
    answer: '福利视频导完全免费！我们的目标是让更多人便捷地发现优质视频内容。所有分类导航、文章阅读、内容推荐功能均不收取任何费用。',
  },
  {
    question: '如何联系福利视频导团队？',
    answer: '您可以访问我们的"关于我们"页面，通过联系表单提交您的意见或建议，也可以发送邮件至我们的官方邮箱。我们会在24小时内回复。',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">
            常见问题
          </h2>
          <p className="text-sm text-secondary-500">关于福利视频导的常见疑问解答</p>
        </div>
        <div className="space-y-3">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="border border-background-200/70 rounded-lg overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer hover:bg-background-100 transition-colors"
              >
                <h3 className="text-sm font-medium text-foreground-900 pr-4">
                  {faq.question}
                </h3>
                <div className={`w-5 h-5 flex items-center justify-center flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`}>
                  <i className="ri-arrow-down-s-line text-secondary-500"></i>
                </div>
              </button>
              {openIndex === index && (
                <div className="px-5 pb-4">
                  <p className="text-sm text-secondary-600 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}